<template>
	<span>
		<vs-chip
	      v-if="badge > 0"
		  color="primary"
			
			class="number  text-white"
			>{{ badge }}</vs-chip
		>
	</span>
</template>

<script>
export default {
	props: {
		badge: {
			type: Number,
			required: true,
		},
	},
};
</script>
